export const LOAD_ORGANIZATION_CONFIGURATIONS_SUCCESS = 'LOAD_ORGANIZATION_CONFIGURATIONS_SUCCESS';
export const LOAD_ORGANIZATION_CONFIGURATIONS_FAILED = 'LOAD_ORGANIZATION_CONFIGURATIONS_FAILED';
